export function formatDate(timestamp, format) {
  var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + "-";
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var D = date.getDate() < 10 ? "0"+date.getDate() : + date.getDate() + "";
  var h = date.getHours() + ":";
  var m = date.getMinutes() + ":";
  var s = date.getSeconds();
  if (format === 1) {
    return Y + M + D +' '+ h + m + s;
  } else if (format === 2) {
    return Y + M + D;
  } else {
    return h + m + s;
  }
}
